const getInitialValue = (data) => ({})

export default getInitialValue
